import React, {Component} from "react";
import Table from "../../components/Table";
import SubscriptionItem from "./SubscriptionItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import gql from "graphql-tag";

class SubscriptionList extends Component {

  render() {
    let {loading, error, subscriptions} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = List([
      "Sub. Id",
      "Seq. Id",
      "Subscribed At",
      "Sub. Name",
      "Recipient",
      "Destination",
      "Freq. Weeks",
      "Products",
      "Status"
    ])          
    return (
      <Table 
        data={fromJS(subscriptions)} 
        renderer={SubscriptionItem} 
        onItemClick={this.handleItemClick.bind(this)}
        tableHeader={tableHeader}
        extraClassName="SubscriptionList"
        itemKey="subscriptionId"
        mode="table"
        showCount={true}
        selected={this.props.selectedId}
        />
    )
  }

  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("subscriptionId");
    let accountId = itemData.get("accountId");
    if (field === "id") {
      e.stopPropagation();
      this.props.onIdClick(id, accountId);
      return;
    }    
    this.props.onSelectionChange(id);
  }  
}


const SUBSCRIPTIONS = gql`
  query subscriptions($filter:SubscriptionFilterInput) {
    subscriptions(filter: $filter) {
      subscriptionId
      name
      accountId
      frequencyWeeks
      status
      currentSeqId
      subscribedAt
      shippingAddress {
        name
        addressStateProvince
        addressCity
        addressCountryCode
      }
      products {
        quantity
      }
    }
  }
`;

const withQuery = graphql(SUBSCRIPTIONS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        shopId: props.shopFilter,
        status: props.statusFilter
      }
    }
  })
})

export default withQuery(SubscriptionList);